import moment from 'moment'

// 深度拷贝对象
export function DeepCopy(obj, iter) {
  if (!obj) return obj
  if (obj instanceof Array) {
    return obj.map(x => DeepCopyCore(x, iter))
  }
  return DeepCopyCore(obj, iter)
}
function DeepCopyCore(obj, iter) {
  const objType = typeof obj
  if (obj == null || obj == undefined ||
       objType == 'string' || objType == 'number' || objType == 'boolean') return obj
  const copy = {}
  for (const key in obj) {
    const prop = obj[key]
    const propType = typeof prop
    if (propType == 'object') {
      if (prop instanceof Array) {
        copy[key] = prop.map(x => DeepCopyCore(x, iter))
      } else {
        copy[key] = DeepCopyCore(prop, iter)
      }
    } else if (propType == 'function') {
      // 跳过函数的复制
    } else {
      copy[key] = prop
    }
  }
  if (iter) iter(copy)
  return copy
}

// https://stackoverflow.com/a/45290208
export function TreeFilter(tree, filter, childrenField = 'children') {
  const getNodes = (result, object) => {
    if (filter(object)) {
      result.push(object)
      return result
    }
    const children = object[childrenField]
    if (Array.isArray(children)) {
      const nodes = children.reduce(getNodes, [])
      if (nodes.length) {
        const newObject = { ...object }
        newObject[childrenField] = nodes
        result.push(newObject)
      }
    }
    return result
  }

  return tree.reduce(getNodes, [])
}

export function TreeLoop(tree, iter, childrenField = 'children') {
  try {
    TreeLoopCore(tree, iter, childrenField)
  } catch { }
}

function TreeLoopCore(tree, iter, childrenField = 'children') {
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    const rtn = iter(node)
    if (rtn == true) {
      continue
    } else if (rtn == false) {
      throw '轮询中断'
    }
    const nodeChildren = node[childrenField]
    if (nodeChildren && nodeChildren.length) {
      TreeLoop(nodeChildren, iter, childrenField)
    }
  }
}

export function MoveToNextInput(container, srcEle) {
  const findInst = input => {
    if (input.parentElement.parentElement.className == 'el-autocomplete') {
      return input.parentElement.parentElement.__vue__
    }

    return input.parentElement.__vue__
  }

  let found = false
  let inst = null
  const inputs = container.getElementsByTagName('input')
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i]
    if (found) {
      inst = findInst(input)
      if (!inst.disabled) {
        inst.focus()
        break
      }
    } else if (input == srcEle) {
      inst = findInst(input)
      if (inst.activated != undefined) inst.activated = false
      found = true
    }
  }
}

// https://blog.csdn.net/gooodi/article/details/88660436
export function FormatSalary(num, scale) {
  if (num == null || num == '' || num == undefined || num == NaN) return num

  if (scale) {
    num = num.toFixed(scale)
  }
  num = num.toString().split('.')
  num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), '$1,')
  return num.join('.')
}

// https://www.cnblogs.com/myprogramer/p/11528131.html
//* ************************ 把数字金额转换成中文大写数字的函数(可处理负值) *********************************/
export function NumberToChinese(money) {
  if (money == null) return money
  if (typeof money === 'string') {
    money = money.replace(/,/g, '')
  }

  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖') // 汉字的数字
  var cnIntRadice = new Array('', '拾', '佰', '仟') // 基本单位
  var cnIntUnits = new Array('', '万', '亿', '兆') // 对应整数部分扩展单位
  var cnDecUnits = new Array('角', '分', '毫', '厘') // 对应小数部分单位
  var cnInteger = '整' // 整数金额时后面跟的字符
  var cnIntLast = '元' // 整型完以后的单位
  var maxNum = 999999999999999.9999 // 最大处理的数字
  var IntegerNum // 金额整数部分
  var DecimalNum // 金额小数部分
  var ChineseStr = '' // 输出的中文金额字符串
  var parts // 分离金额后用的数组，预定义
  var Symbol = ''// 正负值标记
  if (money == '') {
    return ''
  }

  money = parseFloat(money)
  if (money >= maxNum) {
    alert('超出最大处理数字')
    return ''
  }
  if (money == 0) {
    ChineseStr = cnNums[0] + cnIntLast + cnInteger
    return ChineseStr
  }
  if (money < 0) {
    money = -money
    Symbol = '负 '
  }
  money = money.toString() // 转换为字符串
  if (money.indexOf('.') == -1) {
    IntegerNum = money
    DecimalNum = ''
  } else {
    parts = money.split('.')
    IntegerNum = parts[0]
    DecimalNum = parts[1].substr(0, 4)
  }
  if (parseInt(IntegerNum, 10) > 0) { // 获取整型部分转换
    var zeroCount = 0
    var IntLen = IntegerNum.length
    for (var i = 0; i < IntLen; i++) {
      var n = IntegerNum.substr(i, 1)
      var p = IntLen - i - 1
      var q = p / 4
      var m = p % 4
      if (n == '0') {
        zeroCount++
      } else {
        if (zeroCount > 0) {
          ChineseStr += cnNums[0]
        }
        zeroCount = 0 // 归零
        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
      }
      if (m == 0 && zeroCount < 4) {
        ChineseStr += cnIntUnits[q]
      }
    }
    ChineseStr += cnIntLast
    // 整型部分处理完毕
  }
  if (DecimalNum != '') { // 小数部分
    var decLen = DecimalNum.length
    for (var i = 0; i < decLen; i++) {
      var n = DecimalNum.substr(i, 1)
      if (n != '0') {
        ChineseStr += cnNums[Number(n)] + cnDecUnits[i]
      }
    }
  }
  if (ChineseStr == '') {
    ChineseStr += cnNums[0] + cnIntLast + cnInteger
  } else if (DecimalNum == '') {
    ChineseStr += cnInteger
  }
  ChineseStr = Symbol + ChineseStr

  return ChineseStr
}

// 日期格式化
export function DateFormat(cellValue) {
  var date = cellValue
  if (date == undefined) { return '' }
  return moment(date).format('YYYY-MM-DD')
}

export function DateTimeFormat(cellValue) {
  var date = cellValue
  if (date == undefined) { return '' }
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export function Today() {
  return moment().format('YYYY-MM-DD')
}

export function Now() {
  return moment().format('YYYY-MM-DD HH:mm:ss')
}
